import { Injectable } from '@angular/core';
import { AppSettings } from 'app/app.settings';
import { AttrIndexService } from './attr-index.service';
import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';

export interface ExceptionItem {
	id;
	recordUuid;
	layerId;
	colName: string;
	value: any;
	gqrCode: string;
	reason: string;
	tranxCreate;
}

@Injectable({
	providedIn: 'root'
})
export class ExceptionService {

	constructor(
		private attrIndexService: AttrIndexService,
		private requestService: CommonRequestService,
		private userService: UserService
	) { }

	addException(layerId: number, uuid, colName: string, gqrCode: string, reason: string) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/exception';
			const body: any = {
				layerId: layerId,
				uuId: uuid,
				columnName: colName,
				gqrCode: gqrCode,
				reason: reason,
				sessionOwnerId: this.userService.getUserInfo().userId
			};
			return this.requestService.requestPost(url, body, rsp => resolve(rsp), err => reject(err));
		});
	}
	deleteExceptioin(qxpId) {
		const url = AppSettings.serviceRootUrl + 'azgiv/exception';
		return new Promise((resolve, reject) => {
			this.requestService.requestDelete(url, {
				body: {
					sessionOwnerId: this.userService.getUserInfo().userId,
					qxpId: qxpId
				}
			}, rsp => resolve(rsp), err => reject(err));
		});
	}
	getExceptions(layerId, globalIds: any[]) {
		const url = AppSettings.serviceRootUrl + 'azgiv/exception';
		return new Promise<ExceptionItem[]>((resolve, reject) => {
			this.requestService.requestGet(url, {
				params: {
					layerId: layerId, 
					globalIds: JSON.stringify(globalIds)
				}
			}, rsp => {
				const exceptions: ExceptionItem[] = [];
				if (rsp.data) {
					rsp.data.forEach(d => {
						exceptions.push({
							id: d.qxp_id,
							colName: d.qxp_col_name,
							layerId: d.qxp_gly_id,
							gqrCode: d.qxp_gqr_cd,
							reason: d.qxp_reason,
							tranxCreate: d.qxp_tranx_create,
							recordUuid: d['qxp_' + this.attrIndexService.globalIdColStandard],
							value: null // will be filled in component
						});
					});	
				}
				resolve(exceptions);
			}, err => reject(err));
		});
	}
}
